import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import classNames from 'classnames';

const animatedComponents = makeAnimated();

const SelectMultiple = ({
  label,
  value = [], // Accept an array of selected IDs or objects
  onChange,
  onBlur,
  options = [],
  error,
  serverError,
  ...props
}) => {
  const errorClasses = classNames("text-[12px] text-red-500 mt-1", {
    "ml-2": true,
  });

  const transformedValue = Array.isArray(value)
    ? value.map((id) => options.find((option) => option.value === id)).filter(Boolean)
    : [];

  return (
    <div>
      <label className="block mb-1 ml-1 text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <Select
          components={animatedComponents}
          isMulti
          value={transformedValue}
          onChange={(selectedOptions) =>
            onChange(
              selectedOptions ? selectedOptions.map((option) => option.value) : [] 
            )
          }
          onBlur={onBlur}
          options={options}
          className="react-select-container"
          classNamePrefix="react-select"
          {...props}
        />
        {(error || serverError) && (
          <div className={errorClasses}>{error || serverError}</div>
        )}
      </div>
    </div>
  );
};

export default SelectMultiple;
